<template>
  <div class="piano-control piano-personale-control row align-items-baseline">
    <div class="col-auto">
      <FormLabel class="section-title" label-is-fake>{{ label }}</FormLabel>
    </div>
    <div class="col-12 mb-3">
      <button class="btn btn-primary" type="button" :disabled="personnel.length === value.length" @click.prevent="addCost">Aggiungi costo</button>
    </div>
    <div class="col"></div>

    <AwlTable v-if="value.length > 0" class="col-12" :heading="headings" :rows="value">
      <template #column-key-actions="{ rowNumber }">
        <ActionDelete :show-icons-only="true" @click="removeCost(rowNumber)" />
      </template>

      <template #column-key-costId="{ value, rowNumber }">
        <FormInputSelect
          :value="value"
          :options="personnelOptions[rowNumber]"
          optionLabel="name"
          optionValue="id"
          @input="updateLibraryCostInCost(rowNumber, $event)"
        />
      </template>

      <template #column-key-hours="{ row, value, rowNumber }">
        <template v-if="!row.cost">-</template>
        <template v-else>
          <div class="input-group">
            <FormInputText type="number" :min="1" :step="1" :value="value" @input="updateHoursInCost(rowNumber, $event)" />
            <div class="input-group-append">
              <div class="input-group-text">ore</div>
            </div>
          </div>
        </template>
      </template>

      <template #column-key-monthsHours="{ row, value, rowNumber }" >
        <div  :key="keyFormInput">
          Da ripartire: {{ hoursToDivide(row) }} ore
          <button size="sm" @click="toggleAccordionRow(rowNumber)" type="button" :class="accordionState[rowNumber] ? 'ml-2 btn btn-primary' : 'ml-2 btn btn-outline-primary'">
            <b-icon-chevron-up v-show="accordionState[rowNumber]"></b-icon-chevron-up>
            <b-icon-chevron-down v-show="!accordionState[rowNumber]"></b-icon-chevron-down>
          </button>

        </div>
        <div v-if="accordionState[rowNumber]" :key="keyFormInput+1">
          <div class="my-3 text-center">
            <button
              class="btn btn-primary col-5 mx-1"
              type="button"
              @click.prevent="divideHoursInMonths(rowNumber)">
              Ripartisci ore su tutti i mesi
            </button>
            <button
              class="btn btn-primary col-5 mx-1"
              type="button"
              @click.prevent="openAddHoursModal(rowNumber)">
              Aggiungi ore al mese
            </button>
          </div>

          <FormInputMonthlyHoursWidget
            :total="row.hours"
            :value="value"
            :firstMonth="firstMonth"
            :lastMonth="lastMonth"
            @input="updateMonthsHoursInCost(rowNumber, $event)"
          />
        </div>
      </template>
    </AwlTable>

    <BModal
      dialog-class="modal--type-dialog"
      id="add-hours-modal"
      ref="add-hours-modal"
      title="Aggiungi ore"
      centered
    >
        <FormInputAmountWidget
          class="col-sm-6"
          label="Totale ore da distribuire"
          v-model.number="hoursToAddToMonths.amount"
          :min="0"
        />
      <template #modal-footer>
        <button class="ml-2 btn btn-primary" @click.prevent="addHoursToMonths">Aggiungi</button>
        <button class="ml-2 btn btn-outline-danger" @click.prevent="$refs['add-hours-modal'].hide()">Chiudi</button>
      </template>
    </BModal>

  </div>
</template>

<script>
import { BIconChevronUp, BIconChevronDown, BModal } from 'bootstrap-vue';
import formatMoney from '@/filters/formatMoney';

export default {
  data () {
    return {
      hoursToAddToMonths: {
        rowNumber: null,
        amount: 0,
      },
      keyFormInput: 0,
      accordionState: new Array(this.value.length).fill(false),
    };
  },
  components: {
    BIconChevronDown,
    BIconChevronUp,
    BModal,
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    FormInputSelect: () => import('@/libs/Form/components/Inputs/FormInputSelect'),
    FormInputMonthlyHoursWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputMonthlyHoursWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
  },
  filters: {
    money: formatMoney,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    personnel: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Personale associato al progetto',
    },
    firstMonth: {},
    lastMonth: {},
  },
  computed: {
    headings () {
      return [
        { key: 'costId', label: 'Risorsa' },
        { key: 'hours', label: 'Ore totali' },
        { key: 'monthsHours', label: 'Ore mensili' },
        { key: 'actions', label: '' },
      ];
    },
    usedPersonnel () {
      return (this.personnel || []).filter(p => (this.value || []).find(v => v.costId === p.id));
    },
    personnelOptions () {
      return this.value.map((v, i) => {
        return (this.personnel || []).filter(p => {
          return p.id === v.costId || !this.usedPersonnel.find(up => up.id === p.id);
        });
      });
    },
  },
  methods: {
    openAddHoursModal (rowNumber) {
      this.hoursToAddToMonths.rowNumber = rowNumber;
      this.$refs['add-hours-modal'].show();
    },
    addHoursToMonths () {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === this.hoursToAddToMonths.rowNumber) {
          r.hours = r.hours + this.hoursToAddToMonths.amount;
        }

        return r;
      }));
      this.divideHoursInMonths(this.hoursToAddToMonths.rowNumber);
      this.$refs['add-hours-modal'].hide();
    },
    hoursToDivide (row) {
      const hoursAmount = row.monthsHours.reduce((t, v) => t + v.hours, 0);
      return row.hours - hoursAmount;
    },
    toggleAccordionRow (rowNumber) {
      this.accordionState[rowNumber] = !this.accordionState[rowNumber];
      this.keyFormInput++;
    },
    divideHoursInMonths (rowNumber) {
      const newValue = (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          let monthsHours = [...new Map(r.monthsHours.map(item => [item.month, item])).values()];
          const hoursPerMonth = parseInt(r.hours / monthsHours.length);
          const hoursDiff = r.hours - (hoursPerMonth * monthsHours.length);

          monthsHours = monthsHours.map((month, i) => {
            if (hoursDiff > 0 && i === monthsHours.length - 1) {
              return ({ ...month, hours: hoursPerMonth + hoursDiff });
            }
            return ({ ...month, hours: hoursPerMonth });
          },
          );
          return { ...r, monthsHours };
        }
        return r;
      });
      this.$emit('input', (newValue || []));
    },
    addCost () {
      const newValue = [...this.value];
      newValue.push({
        cost: null,
        costId: null,
        hours: 1,
        monthsHours: [],
      });

      this.$emit('input', newValue);
    },
    removeCost (rowNumber) {
      this.$emit('input', (this.value || []).filter((r, i) => i !== rowNumber));
    },
    findCost (costId) {
      return this.personnel.find(c => c.id === costId);
    },
    updateHoursInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.hours = parseInt(value) || 0;
        }

        return r;
      }));
    },
    updateMonthsHoursInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.monthsHours = value || [];
        }

        return r;
      }));
    },
    updateLibraryCostInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          const cost = this.findCost(value);

          if (cost) {
            r.costId = value || null;
            r.cost = cost;
          }
        }

        return r;
      }));
    },
  },
};

</script>

<style lang="scss">
.piano-control {
  .accordion-icon {
    text-align: center;
  }
}
</style>
